import React from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import messages from "components/messagesDescription";
import { Button } from "cxa-components";
import BenefitPanel from "./BenefitPanelPP";
import { prepareValidationData } from "./EnrollmentDataUtil";
import { validateEnrolmentSelection } from "../../../actions/enrollmentActions";
const PlanBasedOptionalBenefits = ({ activeStep, goPrevious, saveEnrolment, intl, errMsg }) => {
  const dispatch = useDispatch();
  const enrollmentDetails = useSelector(state => state.enrollment.details);
  const steps = useSelector(state => state.enrollment.settings.enrolmentPages) || [];
  const benefits = enrollmentDetails.planBasedOptionalBenefits;

  const validateEnrolment = () => {
    const data = prepareValidationData(enrollmentDetails);
    dispatch(
      validateEnrolmentSelection(
        [...data.planBasedBenefits, ...data.planBasedOptionalBenefits],
        goPrevious
      )
    );
  };

  return (
    <div className="benefit-container">
      <span className="page-header">
        <strong>
          {intl.formatMessage({
            id: steps[activeStep].benefitTypeName,
            defaultMessage: steps[activeStep].benefitTypeName,
          })}
        </strong>
      </span>
      {benefits &&
        benefits.map(benefit => {
          return (
            <BenefitPanel
              key={benefit.benefitID}
              benefit={benefit}
              intl={intl}
              selectionMode={benefits.selectionMode}
            />
          );
        })}
      {errMsg}
      <div
        className="btn-container"
        style={{
          justifyContent: `${activeStep > 0 ? "space-between" : "flex-end"}`,
        }}
      >
        {activeStep > 0 && (
          <Button className="enrolment-btn" secondary type="button" onClick={validateEnrolment}>
            {intl.formatMessage(messages.enrollment.goPreviousDescription)}
          </Button>
        )}
        <Button primary type="button" className="enrolment-btn" onClick={saveEnrolment}>
          {activeStep == steps.length - 2
            ? intl.formatMessage(messages.enrollment.previewDescription)
            : intl.formatMessage(messages.enrollment.goNextDescription)}
        </Button>
      </div>
    </div>
  );
};

PlanBasedOptionalBenefits.propTypes = {
  activeStep: PropTypes.number.isRequired,
  goPrevious: PropTypes.func.isRequired,
  saveEnrolment: PropTypes.func.isRequired,
  intl: PropTypes.func,
  errMsg: PropTypes.string,
};

export default PlanBasedOptionalBenefits;



// WEBPACK FOOTER //
// ./components/employee/shop/PlanBasedOptionalBenefits.js